module.exports = __webpack_public_path__ + "img/mute1.e1138192.png";